import { loginRequiredActive } from '@/componentRouter.active';

/**
 *
 * @param $stateProvider
 */
export default function bookingRouter(
  $stateProvider
){
  'ngInject';

  $stateProvider
    .state({
        name: 'booking',
        url: '/booking',
        template: '<booking></booking>'
      })
      .state({
        name: 'bookingUpdate',
        url: '/booking/:id/update',
        template: '<booking-update></booking-update>'
      })
      .state({
        name: 'bookingMulti',
        url: '/bookingMulti',
        template: '<booking-multi></booking-multi>'
      });
}


/** WEBPACK FOOTER **
 ** ./frontend/components/booking/booking.router.js
 **/